module.exports = __webpack_public_path__ + "static/media/law.0ce12282.jpg";